import React from "react";
import "./careerSupport.css";

import { Row, Card, Col, Container } from "reactstrap";

import FontAwesome from "react-fontawesome";

const CareerSupport = props => {
  return (
    <div className="mt-5">
      <section className="career-support mt-5 ">
        <Container className="mt-5 ">
          <Row className="career-headline justify-content-center">
            <Col xs={{ size: 11 }} lg={{offset:1}}>
              <h1 className=" left-align">Career Support</h1>
              <hr className="career-underline mb-5" />
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col
              sm={{ size: 5 }} 
              className="py-2 py-lg-3 py-xl-0 d-flex align-items-center "
            >
              <Row>
                <Col className="" xs={{ size: 12 }} lg={{ size: 12 }}>
                  <Row className="justify-content-center justify-content-md-start">
                    <Col xs={{ size: 11 }}>
                      <h3 className="section-context">
                        Learn how to ace your next job interview or
                        presentation. Get the professional development tools you
                        need to propel your career with our expert-led elevator
                        pitch.
                      </h3>
                    </Col>
                  </Row>
                  <Row className="justify-content-center justify-content-md-start">
                    <Col xs={{ size: 1 }}>
                      <FontAwesome
                        name='career'
                        className="fas fa-circle career-icon "
                        size="2x"
                      />
                    </Col>
                    <Col
                      xs={{ size: 10 }}
                      md={{ size: 8 }}
                      className="mentor-headings pl-2"
                    >
                     Portfolio and Resume
                    </Col>
                  </Row>
                  <Row className="justify-content-center justify-content-md-start pb-3">
                    <Col
                      className="career-section-content"
                      xs={{ size: 11, offset: 1 }}
                      md={{ size: 10, offset: 1 }}
                    >
                 
                     Our career experts will help you refine your resume and portfolio to keep you competitive in the industry. With our partners, we’ll make sure you get the experience and work you need to showcase your skills.
                    </Col>
                  </Row>
                  <Row className="justify-content-center justify-content-md-start">
                    <Col xs={{ size: 1 }}>
                      <FontAwesome
                        name='career'
                        className="fas fa-circle career-icon "
                        size="2x"
                      />
                    </Col>
                    <Col
                      xs={{ size: 10 }}
                      md={{ size: 8 }}
                      className="mentor-headings pl-2"
                    >
                     Technical Interviews and Challenges
                    </Col>
                  </Row>
                  <Row className="justify-content-start  justify-content-md-start pb-3">
                    <Col
                      className="career-section-content "
                      xs={{ size: 11, offset: 1 }}
                      md={{ size: 10, offset: 1 }}
                    >
                     We’ll help you prepare for both technical and behavioral interviews and interview challenges. From problem solving exercises to workshops, we’ll make sure you’re equipped.
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col sm={{ size: 5 }} lg={{size:5}} className='pt-2 pt-lg-5'>
              <Card className="career-support-img">{props.children}</Card>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default CareerSupport;
